import createResourceSelectors from 'store/utils/createResourceSelectors'

export default createResourceSelectors('certificates')
